module.exports = __webpack_public_path__ + "img/folder-secure.98997346.svg";